import React from "react";
import { useTranslation } from "react-i18next";

const HoursAvailabilityCell = ({
  availableFromTime,
  availableToTime,
}: {
  availableFromTime?: string | null;
  availableToTime?: string | null;
}) => {
  const { t } = useTranslation();
  if (!availableFromTime || !availableToTime) {
    return <span>{t("services.activity.common.na", "N/A")}</span>;
  }
  return <span>{`${availableFromTime} - ${availableToTime}`}</span>;
};

export default HoursAvailabilityCell;
